import { createEnrichMetricRequest } from './state/metricsSlice'
import { getStore } from 'app/state/storeRegistry'

/**
 * Send metrics when processing jobs finished.
 * In job metadata, set an object event with a name property. The name should be one of the keys on METRICS_EVENTS
 * Then create a sagas funcion on metricsSagas and related them in the dictionary below
 */

export const METRICS_EVENTS = {
  DO_ENRICHMENT_CREATED: 'DOEnrichmentCreated'
}

const dictionary = {
  [METRICS_EVENTS.DO_ENRICHMENT_CREATED]: createEnrichMetricRequest
}
export function getMetricsSagasFunction(name: string) {
  return dictionary[name] ?? null
}

export function attachTenantId<T>(payload: T) {
  return {
    ...payload,
    tenantId: getStore().getState().users.me?.user_metadata.tenant_id as string
  }
}
